export default "__VITE_PUBLIC_ASSET__592ffcbf__"